export enum ApprovalStatus {
    Approved = 'APPROVED',
    Revoked = 'REVOKED',
}
